import { Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { PageLayout } from 'components/PageLayout';
import { ProfileLayout } from 'components/ProfileLayout';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { getModelProvider } from 'features/wildfires/components/ModelProviderAttribution';

export const ModelProviderProfile = (
  props: RouteComponentProps<{ geoEventId: string; source: string }>,
): JSX.Element => {
  const {
    match: {
      params: { geoEventId, source },
    },
  } = props;
  const { t } = useTranslation();

  const provider = getModelProvider(source);

  if (!provider) {
    return <Redirect to={`/i/${geoEventId}?tab=info`} />;
  }

  const handleLearnMore = async (): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({
        url: provider.learnMoreUrl,
        presentationStyle: 'popover',
      });
    } else {
      window.open(provider.learnMoreUrl, '_blank', 'noopener');
    }
  };

  return (
    <PageLayout
      data-cname="ModelProviderProfilePage"
      headerBarProps={{ action: 'back' }}
    >
      <ProfileLayout
        documentTitle={provider.displayName}
        imageUrl={provider.logoIcon}
        imageAlt={provider.displayName}
        title={provider.displayName}
        subtitle={t('wildfireProgressionModel.modelProvider')}
        actions={
          <Button
            fullWidth
            size="large"
            color="neutral"
            onClick={handleLearnMore}
            endIcon={<OpenInNewIcon sx={{ color: 'text.secondary' }} />}
          >
            {t('wildfireProgressionModel.learnMore')}
          </Button>
        }
      >
        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
          <Trans
            i18nKey={`wildfireProgressionModel.providers.${provider.source}.profileDescription`}
            components={{
              1: <span style={{ fontWeight: 500 }} />,
            }}
          />
        </Typography>
      </ProfileLayout>
    </PageLayout>
  );
};
